import React from 'react'

// Review Board badge — promotional element on attorney profiles. Founding
// members get a distinct gold treatment; standard board members teal.
// Renders nothing for non-members.
export function BoardBadge({ tier, member, className = '' }) {
  const isMember = member || tier === 'founding' || tier === 'standard'
  if (!isMember) return null
  const founding = tier === 'founding'
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold ${
        founding
          ? 'bg-amber-100 text-amber-800 ring-1 ring-amber-300'
          : 'bg-teal-100 text-teal-800 ring-1 ring-teal-300'
      } ${className}`}
    >
      <span aria-hidden>★</span>
      {founding ? 'Founding Review Board Member' : 'Review Board Member'}
    </span>
  )
}

export default BoardBadge
